import { Comment } from "../comment.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class CommentSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new Comment();
        this._copyAttributes(gp, data);
        return gp;

    }

}
